/** Use the configured landing page after login. */
export function loginRedirectUri(origin: string, requestedPath: string, landingRoute: string): string {
  const requested = new URL(requestedPath, origin);
  const landing = String(landingRoute || '').trim().replace(/^\/+/, '');
  const path = landing ? `/${landing}` : `${requested.pathname}${requested.search}${requested.hash}`;
  return `${origin}${path}`;
}
